var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import chmService from "@/core/services/chmService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Tipo_CampoActions } from "@/store/enums/chmEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Tipo_CampoModule = class Tipo_CampoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Tipo_CampoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            chmService.getFile("Tipo_Campo/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Tipo_Campo.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Tipo_CampoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            chmService.postFile("Tipo_Campo/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Tipo_CampoActions.POST_TIPO_CAMPO](data) {
        return new Promise(resolve => {
            chmService.post("Tipo_Campo/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Tipo_CampoActions.PUT_TIPO_CAMPO](data) {
        return new Promise(resolve => {
            chmService.put("Tipo_Campo/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Tipo_CampoActions.DELETE_TIPO_CAMPO](data) {
        return new Promise(resolve => {
            chmService.delete("Tipo_Campo/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Tipo_CampoActions.DELETE_RANGE_TIPO_CAMPO](data) {
        return new Promise(resolve => {
            chmService.delete("Tipo_Campo/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Tipo_CampoActions.FILTER_TIPO_CAMPO](data) {
        return new Promise(resolve => {
            chmService.post("Tipo_Campo/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Tipo_CampoActions.GET_TIPO_CAMPO]() {
        return new Promise(resolve => {
            chmService.get("Tipo_Campo/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Tipo_CampoActions.GETWITHDISABLED_TIPO_CAMPO]() {
        return new Promise(resolve => {
            chmService.get("Tipo_Campo/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Tipo_CampoActions.GET_BY_ID_TIPO_CAMPO](data) {
        return new Promise(resolve => {
            chmService.get("Tipo_Campo/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_CampoModule.prototype, _k, null);
Tipo_CampoModule = __decorate([
    Module
], Tipo_CampoModule);
export default Tipo_CampoModule;
//# sourceMappingURL=Tipo_CampoModule.js.map